import React, { useContext, useState } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Card from '@mui/material/Card';
import Login from './Login'; // Import your Login component file
import Register from './Register'; // Import your Register component file
import { useNavigate } from 'react-router-dom';
import consts from '../Utilities/appConsts.json';
import { LanguageContext } from "../language/LanguageContext";
import useIframeParams from '../hook/useIframeParam';



const AuthenticationForm: React.FC = () => {
  const [activeTab, setActiveTab] = useState(1);
  const navigate = useNavigate();
  const [cardClassName, setCardClassName] = useState("card card-login");
  const { getTranslation } = useContext(LanguageContext);
  const channel = useIframeParams('channel') || "";
  const temptoken = useIframeParams('temptoken') || "";
  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
    setCardClassName(newValue === 0 ? "card card-register" : "card card-login");
  };

  const handleForgetPasswordClick = () => {
    navigate(`${consts.FORGET_PASSWORD_PAGE}?channel=${channel}&temptoken=${temptoken}`); 
  };

  return (
    <div>
    <Card className={cardClassName}>
      <div className="login-register-div">
        <Tabs
          className='tabs-gap'
          value={activeTab}
          onChange={handleTabChange}
          aria-label="טפסי התחברות והרשמה"
          selectionFollowsFocus
        >
          <Tab
            sx={{ fontWeight: activeTab === 0 ? 600 : 400 }}
            label={getTranslation(consts.TO_REGISTER)}
            id="register-tab"
            aria-controls="register-tabpanel"
            aria-label={getTranslation(consts.TO_REGISTER)}
            tabIndex={0}
          />
          <Tab
            sx={{ fontWeight: activeTab === 1 ? 600 : 400 }}
            label={getTranslation(consts.TO_LOGIN)}
            id="login-tab"
            aria-controls="login-tabpanel"
            aria-label={getTranslation(consts.TO_LOGIN)}
            tabIndex={0}
          />
        </Tabs>
      </div>
      <div
        role="tabpanel"
        id={activeTab === 0 ? "register-tabpanel" : "login-tabpanel"}
        aria-labelledby={activeTab === 0 ? "register-tab" : "login-tab"}
      >
        {activeTab === 0 ? (
          <Register />
        ) : (
          <Login onForgetPasswordClick={handleForgetPasswordClick} />
        )}
      </div>
    </Card>
  </div>
  );
};

export default AuthenticationForm;
